<template>
    <adaptive-modal
        name="address-details"
        :hide-action-buttons="true"
        @before-open="beforeOpen"
    >
        <div v-if="address">
            <address-details-list
                v-if="currentView === 'address-details-list'"
                :project-type="projectType"
                :address="address"
                @changeView="changeView"
            />

            <edit-address-details
                v-if="currentView === 'edit-address-details'"
                :address="address"
                :edit-type="currentEditType"
                @changeView="changeView"
                @updateAddress="updateAddress"
            />
        </div>
    </adaptive-modal>
</template>
<script>
    import AddressDetailsList from './AddressDetailsList';
    import EditAddressDetails from './EditAddressDetails';

    export default {
        components: {
            AddressDetailsList,
            EditAddressDetails,
        },
        props: {
            projectType: {
                type: String,
                default: 'deliveryProject',
            },
        },
        data() {
            return {
                address: null,
                currentView: 'address-details-list',
                currentEditType: '',
            };
        },
        created() {
            EventBus.$on('remove-address-marker', () => {
                this.$modal.hide('address-details');
            });
        },
        methods: {
            beforeOpen(obj) {
                this.address = obj.params;
            },

            changeView(view, data) {
                this.currentView = view;
                this.currentEditType = data;
            },

            updateAddress(address) {
                this.address = address;
                this.$emit('updatedAddress', address);
            },
        },
    };
</script>
